import React from 'react';

const LinkPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: false,
			},
		},
	},
	routes: [
		{
			path: '/admin/archive-link/:id/:username/:password/:region/:jobName/:requests',
			exact: true,
			component: React.lazy(() => import('./LinkPage')),
		},
	],
};

export default LinkPageConfig;
